import { AccountLimits, PlanLimits, PlanType, QuotaStatus } from "./types";

/**
 * QuotaStatusのヘルパー関数
 */
export const createQuotaStatus = (limit: number, used = 0): QuotaStatus => ({
  limit,
  used,
  remaining: limit === -1 ? -1 : Math.max(0, limit - used),
  unlimited: limit === -1,
  accessDenied: limit === 0,
});

/**
 * プランごとの制限値（デフォルト値）
 *
 * @see subscription.md for plan details
 */
export const PLAN_LIMITS: Record<PlanType, PlanLimits> = {
  [PlanType.TRIAL]: {
    players: createQuotaStatus(1),
    projects: createQuotaStatus(1),
    aiChatDaily: createQuotaStatus(4),
    aiImageDaily: createQuotaStatus(1),
    aiImagePerRequest: createQuotaStatus(1),
    assets: createQuotaStatus(104857600), // 100MB
  },
  [PlanType.FREE]: {
    players: createQuotaStatus(2),
    projects: createQuotaStatus(5),
    aiChatDaily: createQuotaStatus(8),
    aiImageDaily: createQuotaStatus(2),
    aiImagePerRequest: createQuotaStatus(1),
    assets: createQuotaStatus(1073741824), // 1GB
  },
  [PlanType.STANDARD]: {
    players: createQuotaStatus(4),
    projects: createQuotaStatus(10),
    aiChatDaily: createQuotaStatus(-1),
    aiImageDaily: createQuotaStatus(10),
    aiImagePerRequest: createQuotaStatus(1),
    assets: createQuotaStatus(5368709120), // 5GB
  },
  [PlanType.PREMIUM]: {
    players: createQuotaStatus(8),
    projects: createQuotaStatus(10),
    aiChatDaily: createQuotaStatus(-1),
    aiImageDaily: createQuotaStatus(-1),
    aiImagePerRequest: createQuotaStatus(3),
    assets: createQuotaStatus(53687091200), // 50GB
  },
  [PlanType.BUILDER]: {
    players: createQuotaStatus(10),
    projects: createQuotaStatus(-1),
    aiChatDaily: createQuotaStatus(-1),
    aiImageDaily: createQuotaStatus(-1),
    aiImagePerRequest: createQuotaStatus(3),
    assets: createQuotaStatus(53687091200), // 50GB
  },
  // EDUCATION: プレイヤー数以外は PREMIUM と同等
  [PlanType.EDUCATION]: {
    players: createQuotaStatus(20),
    projects: createQuotaStatus(10),
    aiChatDaily: createQuotaStatus(-1),
    aiImageDaily: createQuotaStatus(-1),
    aiImagePerRequest: createQuotaStatus(3),
    assets: createQuotaStatus(-1), // 無制限
  },
};

/**
 * デフォルトプラン
 */
export const DEFAULT_PLAN = PlanType.TRIAL;

/**
 * 無制限のQuotaStatusを作成（表示専用）
 */
export const createUnlimitedQuotaStatus = (used = 0): QuotaStatus => ({
  limit: -1,
  used,
  remaining: -1,
  unlimited: true,
  accessDenied: false,
});

/**
 * デフォルトのアカウント単位の制限値
 */
export const DEFAULT_ACCOUNT_LIMITS: AccountLimits = {
  players: createQuotaStatus(1),
  assets: createQuotaStatus(104857600), // 100MB
  chatHistoryLimit: createUnlimitedQuotaStatus(), // 無制限（表示専用）
};
